import React, { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import { KTSVG } from '../../../_metronic/helpers';

function Activo() { return <span className="badge badge-light-success">Activo</span>; }
function Prueba() { return <span className="badge badge-light-success bg-prueba">Prueba</span>; }
function Promocion() { return <span className="badge badge-light-success bg-prueba">Promoción</span>; }
function PagoFallido() { return <span className="badge badge-light-danger">Pago Fallido</span>; }
function Cancelado() { return <span className="badge badge-light-danger">Cancelado</span>; }
function NoPagado() { return <span className="badge badge-light-danger bg-no-pagado">No Pagado</span>; }
function Sistema() { return <span className='badge badge-light bg-sistema'>Sistema</span>; }
function Demo() { return <span className='badge badge-light bg-sistema'>Demo</span>; }

function Status({ statusPago }) {
  switch (statusPago) {
    case 'Prueba': return <Prueba />;
    case 'Promocion': return <Promocion />;
    case 'Activo': return <Activo />;
    case 'Pago fallido': return <PagoFallido />;
    case 'Cancelado': return <Cancelado />;
    case 'No Pagado': return <NoPagado />;
    case 'Sistema': return <Sistema />;
    case 'Demo': return <Demo />;
    default: return <NoPagado />;
  }
}

function Plan({ plan }) {
  switch (plan) {
    case 'Adinte Anual': return "Adinte Anual";
    case 'Adinte Mensual': return "Adinte Mensual";
    case 'Admin': return "Admin";
    case 'Starter Mensual': return "Adinte Starter Mensual";
    case 'Starter Anual': return "Adinte Starter Anual";
    case 'Professional Mensual ': return "Adinte Professional Mensual";
    case 'Professional Anual': return "Adinte Professional Anual";
    default: return "N/A";
  }
}

export function TablaUsuarios({ usuarios, showUser, editUser, deleteUser, excelButtonId }) {

  /* =================== EXCEL =================== */
  const exportExcel = () => {
    const data = usuarios.map(u => ({
      Nombre: `${u.first_name} ${u.last_name}`,
      Plan: u.plan,
      Status: u.subscription,
      Teléfono: u.phone,
      Correo: u.email,
      Empresa: u.company,
      'Número de empleados': u.employees,
      Estado: u.state,
      Ciudad: u.city,
      Expedientes: u.total_exp,
      'Días restantes': u.expiration_time,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Usuarios');
    XLSX.writeFile(workbook, 'usuarios.xlsx');
  };

  useEffect(() => {
    if (excelButtonId) {
      const btn = document.getElementById(excelButtonId);
      if (btn) btn.addEventListener('click', exportExcel);
      return () => btn && btn.removeEventListener('click', exportExcel);
    }
  }, [usuarios, excelButtonId]);

  /* =================== COLUMNAS =================== */
  const columns = [
    { name: 'Nombre', selector: row => `${row.first_name} ${row.last_name}`, sortable: true, wrap: true, grow: 2 },
    { name: 'Plan', cell: row => <Plan plan={row.plan} />, sortable: true, wrap: true },
    { name: 'Status', cell: row => <Status statusPago={row.subscription} />, sortable: true, wrap: true },
    /*{ name: 'Teléfono', selector: row => row.phone, sortable: true, wrap: true },*/
    { name: 'Correo', selector: row => row.email, sortable: true, wrap: true, grow: 2 },
    /*{ name: 'Empresa', selector: row => row.company, sortable: true, wrap: true, grow: 2 },*/
    /*{ name: 'Número de empleados', selector: row => row.employees, sortable: true, wrap: true },*/
    /*{ name: 'Estado', selector: row => row.state, sortable: true, wrap: true },*/
    /*{ name: 'Ciudad', selector: row => row.city, sortable: true, wrap: true },*/
    { name: 'Expedientes', selector: row => row.total_exp, sortable: true, wrap: true },
    { name: 'Días restantes', selector: row => row.expiration_time, sortable: true, wrap: true },
    {
      name: 'Acciones',
      cell: row => (
        <>
          <button
            className='btn btn-icon btn-secondary btn-sm me-1'
            onClick={() => showUser(row.id)}
            title="Ver"
          >
            <i className="fas fa-eye"></i>
          </button>

          <button
            className='btn btn-icon btn-primary btn-sm me-1'
            onClick={() => editUser(row.id)}
            title="Editar"
          >
            <i className="fas fa-edit"></i>
          </button>

          <button
            className='btn btn-icon btn-danger btn-sm'
            onClick={() => deleteUser(row.id)}
            title="Eliminar"
          >
            <i className="fas fa-trash"></i>
          </button>
        </>
      )
    }
  ];

  /* =================== ESTILOS =================== */
  const customStyles = {
    headCells: {
      style: {
        fontWeight: 'bold',
        fontSize: '14px',
        backgroundColor: '#f3f6f9',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.4'
      }
    },
    cells: {
      style: {
        fontSize: '13px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.4'
      }
    }
  };

  return (
    <DataTable
      columns={columns}
      data={usuarios}
      pagination
      paginationPerPage={100}
      paginationRowsPerPageOptions={[100, 200, 300, usuarios.length]}
      highlightOnHover
      responsive
      
      striped
      noDataComponent="No hay registros"
      customStyles={customStyles}
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
      }}
    />
  );
}